import { LinkTwoTone } from '@material-ui/icons';
import React from 'react';
import { useHistory } from 'react-router-dom';
import AdminStamp from '../../AdminStamp';
import { CommittePackageName, CommittePackageTitle, PackageBox, PackageCommitteLink, PackageListContainer } from './styles';

interface IPackage {
  name: string;
  id: string;
  active: boolean;
  admin: boolean;
}

interface ICommitteePackagesListProps {
  packages: IPackage[];
}

const CommitteePackagesList = ({packages}: ICommitteePackagesListProps) => {
  const history = useHistory();

  return (
    <PackageListContainer>
      {packages.map((committePackage) => (
        <PackageBox key={committePackage.id}>
          <CommittePackageTitle>
            <CommittePackageName>
              {committePackage.name}
            </CommittePackageName>

            {committePackage.admin && (
              <AdminStamp name="Admin" color="#f96e6e" />
            )}
          </CommittePackageTitle>
          
          <PackageCommitteLink 
            onClick={() => {
              window.open(`/system-management/configure-committee-packages?id=${committePackage.id}`, '_blank')
            }}
          >
            <LinkTwoTone />
          </PackageCommitteLink>
        </PackageBox>        
      ))}
    </PackageListContainer>      
  );
};

export default CommitteePackagesList;